import { trpc } from "@/Utils/trpc";
import { LogoTile } from "@/components/LogoTile";

type Props = {
  displayName: string;
};

export const HeaderLogo: React.FC<Props> = ({ displayName }) => {
  const { data: logoData, isLoading } = trpc.siteStorage.getLogo.useQuery();

  if (isLoading) {
    return <div className="h-[48px] w-[48px] rounded-md bg-neutral-100" />;
  }

  return (
    <LogoTile
      logoUrl={logoData?.url ?? null}
      displayName={displayName}
      size={30}
      variant="rounded"
    />
  );
};
